import { useQuery } from "@tanstack/react-query";
import { StreamsCategories } from "@graylog/enterprise-api";
const STREAM_CATEGORIES_KEY = ["stream-categories"];
const fetchStreamCategories = () => StreamsCategories.getAllCategories();
const useStreamCategories = (enabled = true) => {
  const { data, isLoading } = useQuery({
    queryKey: STREAM_CATEGORIES_KEY,
    queryFn: fetchStreamCategories,
    enabled
  });
  return {
    categories: data != null ? data : [],
    isLoading: isLoading && enabled
  };
};
export default useStreamCategories;
